import React, { useState, useEffect } from 'react';
import { ref, onValue, push, remove, set } from 'firebase/database';
import { database } from '../firebase';
import './AdminPanel.css';

const IMGBB_API_KEY = '88f16d298c527a7bd899cd7fcb518203';

const AdminPanel = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [activeTab, setActiveTab] = useState('products');
  
  // Ürünler
  const [products, setProducts] = useState([]);
  const [newProduct, setNewProduct] = useState({ title: '', description: '', image: null });
  const [uploadingProduct, setUploadingProduct] = useState(false);
  
  // Hizmetler
  const [services, setServices] = useState([]);
  const [newService, setNewService] = useState({ title: '', description: '' });
  
  // Referanslar
  const [references, setReferences] = useState([]);
  const [newReference, setNewReference] = useState({ title: '', image: null });
  const [uploadingReference, setUploadingReference] = useState(false);
  
  // Müşteri Yorumları
  const [testimonials, setTestimonials] = useState([]);
  const [newTestimonial, setNewTestimonial] = useState({ name: '', company: '', comment: '', rating: 5 });
  
  // İletişim Bilgileri
  const [contactInfo, setContactInfo] = useState({
    phone: '0538 412 51 26',
    email: '',
    address: 'İKİTELLİ OSB MAH. AYKOSAN 4 LÜ D BLOK SK. AYKOSAN 4\'LÜ D BLOK NO: 4 D İÇ KAPI NO: 194 BAŞAKŞEHİR/ İSTANBUL',
    workingHours: 'Pazartesi - Cuma: 09:00 - 18:00\nCumartesi: 09:00 - 14:00'
  });

  // Basit şifre kontrolü
  const ADMIN_PASSWORD = 'bulut.2026!';

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      setPassword('');
    } else {
      alert('Yanlış şifre!');
    }
  };

  // imgbb API ile resim yükleme fonksiyonu
  const uploadImageToImgbb = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async () => {
        const base64 = reader.result.split(',')[1];
        
        try {
          const formData = new FormData();
          formData.append('key', IMGBB_API_KEY);
          formData.append('image', base64);

          const response = await fetch('https://api.imgbb.com/1/upload', {
            method: 'POST',
            body: formData
          });
          
          const data = await response.json();
          
          if (data.success && data.data && data.data.url) {
            resolve(data.data.url);
          } else {
            reject(new Error(data.error?.message || data.status_txt || 'Resim yüklenemedi'));
          }
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = () => reject(new Error('Dosya okunamadı'));
    });
  };

  // Realtime Database'den veri dinle
  useEffect(() => {
    if (!isAuthenticated) return;

    // Ürünleri dinle
    const productsRef = ref(database, 'products');
    const unsubscribeProducts = onValue(productsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const productsList = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        setProducts(productsList);
      } else {
        setProducts([]);
      }
    });

    // Hizmetleri dinle
    const servicesRef = ref(database, 'services');
    const unsubscribeServices = onValue(servicesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const servicesList = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        setServices(servicesList);
      } else {
        setServices([]);
      }
    });

    // Referansları dinle
    const referencesRef = ref(database, 'references');
    const unsubscribeReferences = onValue(referencesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const referencesList = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        setReferences(referencesList);
      } else {
        setReferences([]);
      }
    });

    // Müşteri yorumlarını dinle
    const testimonialsRef = ref(database, 'testimonials');
    const unsubscribeTestimonials = onValue(testimonialsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const testimonialsList = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        setTestimonials(testimonialsList);
      } else {
        setTestimonials([]);
      }
    });

    // İletişim bilgilerini yükle
    const contactRef = ref(database, 'contactInfo');
    onValue(contactRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setContactInfo(data);
      }
    });

    return () => {
      unsubscribeProducts();
      unsubscribeServices();
      unsubscribeReferences();
      unsubscribeTestimonials();
    };
  }, [isAuthenticated]);

  // Ürün ekle
  const handleAddProduct = async (e) => {
    e.preventDefault();
    if (newProduct.title && newProduct.description) {
      setUploadingProduct(true);
      try {
        let imageUrl = null;
        if (newProduct.image) {
          imageUrl = await uploadImageToImgbb(newProduct.image);
        }
        
        const productsRef = ref(database, 'products');
        await push(productsRef, {
          title: newProduct.title,
          description: newProduct.description,
          image: imageUrl,
          createdAt: new Date().toISOString()
        });
        setNewProduct({ title: '', description: '', image: null });
        alert('Ürün başarıyla eklendi!');
      } catch (error) {
        console.error('Resim yükleme hatası:', error);
        alert('Resim yüklenirken hata oluştu: ' + error.message);
      } finally {
        setUploadingProduct(false);
      }
    }
  };

  // Hizmet ekle
  const handleAddService = async (e) => {
    e.preventDefault();
    if (newService.title && newService.description) {
      const servicesRef = ref(database, 'services');
      await push(servicesRef, {
        title: newService.title,
        description: newService.description,
        createdAt: new Date().toISOString()
      });
      setNewService({ title: '', description: '' });
      alert('Hizmet başarıyla eklendi!');
    }
  };

  // Ürün sil
  const handleDeleteProduct = async (id) => {
    if (window.confirm('Bu ürünü silmek istediğinize emin misiniz?')) {
      const productRef = ref(database, `products/${id}`);
      await remove(productRef);
    }
  };

  // Hizmet sil
  const handleDeleteService = async (id) => {
    if (window.confirm('Bu hizmeti silmek istediğinize emin misiniz?')) {
      const serviceRef = ref(database, `services/${id}`);
      await remove(serviceRef);
    }
  };

  // Referans ekle
  const handleAddReference = async (e) => {
    e.preventDefault();
    if (newReference.title) {
      setUploadingReference(true);
      try {
        let imageUrl = null;
        if (newReference.image) {
          imageUrl = await uploadImageToImgbb(newReference.image);
        }
        
        const referencesRef = ref(database, 'references');
        await push(referencesRef, {
          title: newReference.title,
          image: imageUrl,
          createdAt: new Date().toISOString()
        });
        setNewReference({ title: '', image: null });
        alert('Referans başarıyla eklendi!');
      } catch (error) {
        console.error('Resim yükleme hatası:', error);
        alert('Resim yüklenirken hata oluştu: ' + error.message);
      } finally {
        setUploadingReference(false);
      }
    }
  };

  // Referans sil
  const handleDeleteReference = async (id) => {
    if (window.confirm('Bu referansı silmek istediğinize emin misiniz?')) {
      const referenceRef = ref(database, `references/${id}`);
      await remove(referenceRef);
    }
  };

  // Müşteri yorumu ekle
  const handleAddTestimonial = async (e) => {
    e.preventDefault();
    if (newTestimonial.name && newTestimonial.comment) {
      const testimonialsRef = ref(database, 'testimonials');
      await push(testimonialsRef, {
        name: newTestimonial.name,
        company: newTestimonial.company || '',
        comment: newTestimonial.comment,
        rating: newTestimonial.rating || 5,
        createdAt: new Date().toISOString()
      });
      setNewTestimonial({ name: '', company: '', comment: '', rating: 5 });
      alert('Müşteri yorumu başarıyla eklendi!');
    }
  };

  // Müşteri yorumu sil
  const handleDeleteTestimonial = async (id) => {
    if (window.confirm('Bu yorumu silmek istediğinize emin misiniz?')) {
      const testimonialRef = ref(database, `testimonials/${id}`);
      await remove(testimonialRef);
    }
  };

  // İletişim bilgilerini kaydet
  const handleSaveContactInfo = async (e) => {
    e.preventDefault();
    const contactRef = ref(database, 'contactInfo');
    await set(contactRef, contactInfo);
    alert('İletişim bilgileri kaydedildi!');
  };

  if (!isAuthenticated) {
    return (
      <div className="admin-login">
        <div className="login-box">
          <h2>Admin Girişi</h2>
          <form onSubmit={handleLogin}>
            <input
              type="password"
              placeholder="Şifre"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="submit">Giriş Yap</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-panel">
      <div className="admin-header">
        <h1>Admin Panel</h1>
        <button onClick={() => setIsAuthenticated(false)} className="logout-btn">
          Çıkış Yap
        </button>
      </div>

      <div className="admin-tabs">
        <button
          className={`tab-button ${activeTab === 'products' ? 'active' : ''}`}
          onClick={() => setActiveTab('products')}
        >
          Ürünler
        </button>
        <button
          className={`tab-button ${activeTab === 'services' ? 'active' : ''}`}
          onClick={() => setActiveTab('services')}
        >
          Hizmetler
        </button>
        <button
          className={`tab-button ${activeTab === 'references' ? 'active' : ''}`}
          onClick={() => setActiveTab('references')}
        >
          Referanslar
        </button>
        <button
          className={`tab-button ${activeTab === 'testimonials' ? 'active' : ''}`}
          onClick={() => setActiveTab('testimonials')}
        >
          Müşteri Yorumları
        </button>
        <button
          className={`tab-button ${activeTab === 'contact' ? 'active' : ''}`}
          onClick={() => setActiveTab('contact')}
        >
          İletişim Bilgileri
        </button>
      </div>

      <div className="admin-content">
        {/* Ürünler Sekmesi */}
        {activeTab === 'products' && (
          <div className="admin-section">
            <h2>Ürünler</h2>
            <form onSubmit={handleAddProduct} className="admin-form">
              <input
                type="text"
                placeholder="Ürün Başlığı"
                value={newProduct.title}
                onChange={(e) => setNewProduct({ ...newProduct, title: e.target.value })}
                required
              />
              <textarea
                placeholder="Ürün Açıklaması"
                value={newProduct.description}
                onChange={(e) => setNewProduct({ ...newProduct, description: e.target.value })}
                required
              />
              <div className="file-input-wrapper">
                <label className="file-label">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setNewProduct({ ...newProduct, image: e.target.files[0] })}
                    className="file-input"
                  />
                  <span className="file-button">
                    {newProduct.image ? newProduct.image.name : 'Resim Seç (Opsiyonel)'}
                  </span>
                </label>
                {newProduct.image && (
                  <button
                    type="button"
                    onClick={() => setNewProduct({ ...newProduct, image: null })}
                    className="remove-file-btn"
                  >
                    ✕
                  </button>
                )}
              </div>
              <button type="submit" disabled={uploadingProduct}>
                {uploadingProduct ? 'Yükleniyor...' : 'Ürün Ekle'}
              </button>
            </form>

            <div className="items-list">
              {products.length === 0 ? (
                <p className="empty-message">Henüz ürün eklenmemiş.</p>
              ) : (
                products.map((product) => (
                  <div key={product.id} className="item-card">
                    {product.image && (
                      <img src={product.image} alt={product.title} className="item-image" />
                    )}
                    <h3>{product.title}</h3>
                    <p>{product.description}</p>
                    <button
                      onClick={() => handleDeleteProduct(product.id)}
                      className="delete-btn"
                    >
                      Sil
                    </button>
                  </div>
                ))
              )}
            </div>
          </div>
        )}

        {/* Hizmetler Sekmesi */}
        {activeTab === 'services' && (
          <div className="admin-section">
            <h2>Hizmetler</h2>
            <form onSubmit={handleAddService} className="admin-form">
              <input
                type="text"
                placeholder="Hizmet Başlığı"
                value={newService.title}
                onChange={(e) => setNewService({ ...newService, title: e.target.value })}
                required
              />
              <textarea
                placeholder="Hizmet Açıklaması"
                value={newService.description}
                onChange={(e) => setNewService({ ...newService, description: e.target.value })}
                required
              />
              <button type="submit">Hizmet Ekle</button>
            </form>

            <div className="items-list">
              {services.length === 0 ? (
                <p className="empty-message">Henüz hizmet eklenmemiş.</p>
              ) : (
                services.map((service) => (
                  <div key={service.id} className="item-card">
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <button
                      onClick={() => handleDeleteService(service.id)}
                      className="delete-btn"
                    >
                      Sil
                    </button>
                  </div>
                ))
              )}
            </div>
          </div>
        )}

        {/* Referanslar Sekmesi */}
        {activeTab === 'references' && (
          <div className="admin-section">
            <h2>Referanslar</h2>
            <form onSubmit={handleAddReference} className="admin-form">
              <input
                type="text"
                placeholder="Referans Başlığı (örn: Kafe Zincirleri)"
                value={newReference.title}
                onChange={(e) => setNewReference({ ...newReference, title: e.target.value })}
                required
              />
              <div className="file-input-wrapper">
                <label className="file-label">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setNewReference({ ...newReference, image: e.target.files[0] })}
                    className="file-input"
                  />
                  <span className="file-button">
                    {newReference.image ? newReference.image.name : 'Resim Seç (Opsiyonel)'}
                  </span>
                </label>
                {newReference.image && (
                  <button
                    type="button"
                    onClick={() => setNewReference({ ...newReference, image: null })}
                    className="remove-file-btn"
                  >
                    ✕
                  </button>
                )}
              </div>
              <button type="submit" disabled={uploadingReference}>
                {uploadingReference ? 'Yükleniyor...' : 'Referans Ekle'}
              </button>
            </form>

            <div className="items-list">
              {references.length === 0 ? (
                <p className="empty-message">Henüz referans eklenmemiş.</p>
              ) : (
                references.map((reference) => (
                  <div key={reference.id} className="item-card">
                    {reference.image && (
                      <img src={reference.image} alt={reference.title} className="item-image" />
                    )}
                    <h3>{reference.title}</h3>
                    <button
                      onClick={() => handleDeleteReference(reference.id)}
                      className="delete-btn"
                    >
                      Sil
                    </button>
                  </div>
                ))
              )}
            </div>
          </div>
        )}

        {/* Müşteri Yorumları Sekmesi */}
        {activeTab === 'testimonials' && (
          <div className="admin-section">
            <h2>Müşteri Yorumları</h2>
            <form onSubmit={handleAddTestimonial} className="admin-form">
              <input
                type="text"
                placeholder="Müşteri Adı"
                value={newTestimonial.name}
                onChange={(e) => setNewTestimonial({ ...newTestimonial, name: e.target.value })}
                required
              />
              <input
                type="text"
                placeholder="Şirket Adı (Opsiyonel)"
                value={newTestimonial.company}
                onChange={(e) => setNewTestimonial({ ...newTestimonial, company: e.target.value })}
              />
              <textarea
                placeholder="Yorum"
                value={newTestimonial.comment}
                onChange={(e) => setNewTestimonial({ ...newTestimonial, comment: e.target.value })}
                required
                rows="5"
              />
              <div className="rating-input">
                <label>Değerlendirme (Yıldız):</label>
                <select
                  value={newTestimonial.rating}
                  onChange={(e) => setNewTestimonial({ ...newTestimonial, rating: parseInt(e.target.value) })}
                >
                  <option value={5}>5 Yıldız</option>
                  <option value={4}>4 Yıldız</option>
                  <option value={3}>3 Yıldız</option>
                  <option value={2}>2 Yıldız</option>
                  <option value={1}>1 Yıldız</option>
                </select>
              </div>
              <button type="submit">Yorum Ekle</button>
            </form>

            <div className="items-list">
              {testimonials.length === 0 ? (
                <p className="empty-message">Henüz yorum eklenmemiş.</p>
              ) : (
                testimonials.map((testimonial) => (
                  <div key={testimonial.id} className="item-card">
                    <h3>{testimonial.name}</h3>
                    {testimonial.company && <p style={{ color: '#6b7280', marginBottom: '0.5rem' }}>{testimonial.company}</p>}
                    <div style={{ marginBottom: '0.5rem' }}>
                      {Array.from({ length: 5 }, (_, i) => (
                        <span key={i} style={{ color: i < (testimonial.rating || 5) ? '#fbbf24' : '#d1d5db', fontSize: '1.2rem' }}>
                          ★
                        </span>
                      ))}
                      <span style={{ marginLeft: '0.5rem', color: '#6b7280' }}>({testimonial.rating || 5}/5)</span>
                    </div>
                    <p>{testimonial.comment}</p>
                    <button
                      onClick={() => handleDeleteTestimonial(testimonial.id)}
                      className="delete-btn"
                    >
                      Sil
                    </button>
                  </div>
                ))
              )}
            </div>
          </div>
        )}

        {/* İletişim Bilgileri Sekmesi */}
        {activeTab === 'contact' && (
          <div className="admin-section">
            <h2>İletişim Bilgileri</h2>
            <form onSubmit={handleSaveContactInfo} className="admin-form">
              <div className="form-group">
                <label>Telefon</label>
                <input
                  type="text"
                  value={contactInfo.phone}
                  onChange={(e) => setContactInfo({ ...contactInfo, phone: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>E-posta</label>
                <input
                  type="email"
                  value={contactInfo.email}
                  onChange={(e) => setContactInfo({ ...contactInfo, email: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label>Adres</label>
                <textarea
                  value={contactInfo.address}
                  onChange={(e) => setContactInfo({ ...contactInfo, address: e.target.value })}
                  required
                  rows="3"
                />
              </div>
              <div className="form-group">
                <label>Çalışma Saatleri</label>
                <textarea
                  value={contactInfo.workingHours}
                  onChange={(e) => setContactInfo({ ...contactInfo, workingHours: e.target.value })}
                  required
                  rows="3"
                />
              </div>
              <button type="submit" className="save-btn">Kaydet</button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminPanel;
